var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shouye-bottom"},[_c('Row',[_c('Col',{attrs:{"span":"12"}},[_c('div',[_vm._v("今日工作")]),_c('Table',{attrs:{"columns":_vm.columns1,"data":_vm.data1}})],1),_c('Col',{attrs:{"span":"12"}},[_vm._v("col-12")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }